
// Import FirebaseAuth and firebase.
import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/app';
import 'firebase/auth';
import getConfigFB from '../helpers/ConfigFB';

import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import ButtonAppBar from './material-ui/ButtonAppBar';


// Configure Firebase
firebase.initializeApp(getConfigFB());

const settings = {timestampsInSnapshots: true};
firebase.firestore().settings(settings);

firebase.firestore().enablePersistence()
  .then(function() {
      // Initialize Cloud Firestore through firebase
      console.log("persistance enabled.")
  })   
  .catch(function(err) {
    console.error("Error enabling firestore offline persistence", err);
  });

  const styles = theme => ({
    progress: {
      margin: theme.spacing.unit * 2,
    },
  });

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

function getSignInOptions(){
  let signInOptions = [firebase.auth.FacebookAuthProvider.PROVIDER_ID];
  if (!isFacebookApp()){
    signInOptions.unshift(firebase.auth.GoogleAuthProvider.PROVIDER_ID)
  }
  return signInOptions;
}



class SignInScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = { inCallBack: false };
  }

  signInOptions = [firebase.auth.FacebookAuthProvider.PROVIDER_ID];
    
  // Configure FirebaseUI.
  uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    autoUpgradeAnonymousUsers: true,
    // We will display Google as auth providers.
    signInOptions: getSignInOptions(),
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: () => false,
      // fixme we should handle merge conflict later.
      signInFailure: (error) => {
        //done to hide the login ui.
        this.setState({inCallBack:true})
        if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
          return Promise.resolve();
        }
        return firebase.auth().signInWithCredential(error.credential);
      },
    }
  };

  // Listen to the Firebase Auth state and set the local state.
  componentDidMount() {
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
      (user) => this.props.childProps.userHasAuthenticated(!!user)
    );
  }
  
  // Make sure we un-register Firebase observers when the component unmounts.
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  render() {
    if(this.state.inCallBack) return null; //hide login ui in callback
    if (this.props.childProps.isAuthenticated === null){
      // handle the time before the check with firebase has return.    
      const { classes } = this.props;
      return(
        <div>
          <CircularProgress className={classes.progress} />
        </div>
      );
    }
    // try anonymous silent login.
    if (!this.props.childProps.isAuthenticated) {
      firebase.auth().signInAnonymously().catch(function(error) {
        console.error("Error in anonymous login: ", error);
      });
      return null;  
    }

    if (this.props.childProps.toNamedUser) {
      return (
        <div>
          <ButtonAppBar/>
          <p>Please sign-in:</p>
          <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()}/>
        </div>
      );
    }
    return (
      <div>
        <h1>My App</h1>
        <p>Welcome {firebase.auth().currentUser.displayName}! You are now signed-in!</p>
        <a onClick={() => firebase.auth().signOut()}>Sign-out</a>
      </div>
    );
  }
}

export default withStyles(styles)(SignInScreen);


// WEBPACK FOOTER //
// ./src/components/SignInScreen.js